/**
 * Deep links into a provider's own dashboard, so support can jump from a row
 * here to the place they can act on it.
 *
 * Only links we are sure of: a wrong link that 404s costs more time than no
 * link. Stripe's URL scheme is stable and public. FastSpring's admin app is
 * store-scoped and its path shape is unverified here — FastSpring rows already
 * carry the real `invoiceUrl` the API returned, which is a verified URL, so
 * that is used instead. Add a FastSpring customer link once someone confirms
 * the pattern from a real admin session.
 */
import type { BillingProvider } from "../../../../../shared/index";

export function providerCustomerUrl(
  provider: BillingProvider,
  customerId: string
): string | null {
  if (provider === "stripe") {
    return `https://dashboard.stripe.com/customers/${encodeURIComponent(customerId)}`;
  }
  return null;
}

export function providerSubscriptionUrl(
  provider: BillingProvider,
  subscriptionId: string
): string | null {
  if (provider === "stripe") {
    return `https://dashboard.stripe.com/subscriptions/${encodeURIComponent(subscriptionId)}`;
  }
  return null;
}
